/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { jiraAutocompleteSuggestionSchema } from './jiraAutocompleteSuggestionSchema';

export const jiraAutocompleteSuggestionResponseSchema = z.object({
  get results() {
    return z.array(jiraAutocompleteSuggestionSchema);
  },
});
